import { OperatorSettingsLoacalVideo } from './OperatorSettingsLoacalVideo';

export default OperatorSettingsLoacalVideo;
